export default {
    name: 'app',
    data () {
      return {
        api_key: '715b56edbfcf075b1484b9944b3f8b27',
        url_base: 'https://api.openweathermap.org/data/2.5/',
        query: '',
        searchTime: '',
        weatherDhaka: {},
        weatherMiyazaki: {},
        searchWeatherData: {}
      }
    },
    async created() {
        let queryParam = [['Dhaka, BD','en'], ['Miyazaki, JP','ja']];

        queryParam.map(param => {
            fetch(`${this.url_base}weather?q=${param[0]}&units=metric&lang=${param[1]}&APPID=${this.api_key}`).then(res => {return res.json()}).then(this.setWeatherData);
        })
    },
    methods: {
        setWeatherData(results) {
            if(results){
                switch(results.name){
                    case 'Miyazaki':
                    case '宮崎':
                        return this.weatherMiyazaki = results;
                    case 'Dhaka':
                    case 'ダッカ':
                        return this.weatherDhaka = results;
                }
            }
        },
        fetchWeather (e) {
            if(e.key == 'Enter'){
                fetch(`${this.url_base}weather?q=${this.query}&units=metric&APPID=${this.api_key}`)
                    .then(res => {
                        return res.json();
                    })
                    .then(this.setResults);    
            }
        },
        async setResults (results) {
            this.searchWeatherData = results;
            await fetch(`https://api.timezonedb.com/v2.1/list-time-zone?key=IVUZPP01X4EB&format=json&country=${this.searchWeatherData.sys.country}`)
                .then(res => {
                    return res.json();
                })
                .then(this.setSearchTimeBuilder);
        },
        dateBuilder () {
            let d = new Date();
            let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            let day = days[d.getDay()];
            let date = d.getDate();
            let month = months[d.getMonth()];
            let year = d.getFullYear();
            return `${day} ${date} ${month} ${year}`;
        },
        jpDateBuilder () {
            let d = new Date();
            let months = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
            let days = ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
            let day = days[d.getDay()];
            let date = d.getDate();
            let month = months[d.getMonth()];
            let year = d.getFullYear();
            return `${year}年 ${month} ${date}日 ${day}`;
        },
        timeBuilder () {
            let d = new Date();
            let hours = d.getHours();
            let minutes = d.getMinutes();
            // let sec = d.getSeconds();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0'+minutes : minutes;
            return `${hours}:${minutes} ${ampm}`
        },
        setSearchTimeBuilder (data) {
            let offset = data.zones[0].gmtOffset
            let od = new Date();
            let utc = od.getTime() + (od.getTimezoneOffset() * 60000);
            let d = new Date(utc + (1000*offset));
            let hours = d.getHours();
            let minutes = d.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0'+minutes : minutes;
            console.log(`${hours}:${minutes} ${ampm}`)
            this.searchTime = `${hours}:${minutes} ${ampm}`
        },
        jpTimeBuilder () {
            // let getTime = 'https://api.timezonedb.com/v2.1/list-time-zone?key=IVUZPP01X4EB&format=json&country='
            // let res = fetch(`${getTime}${results.sys.country}`).then(res => {return res.json()});
            // let offset = res.zones.gmtOffset
            let od = new Date();
            let utc = od.getTime() + (od.getTimezoneOffset() * 60000);
            let d = new Date(utc + (3600000*9));
            let hours = d.getHours();
            let minutes = d.getMinutes();
            // let sec = d.getSeconds();
            let ampm = hours >= 12 ? '午後' : '午前';
            hours = hours % 12;
            hours = hours ? hours : 12;
            minutes = minutes < 10 ? '0'+minutes : minutes;
            return `${ampm} ${hours}時 ${minutes}分 `
        }
    },
}

